import type { SavedMapPlotRequestDetail } from "@/features/map/types";

/**
 * 所在・地番・家屋番号の存在チェック（共通バリデーション）
 * @param plot 保存済みプロット詳細
 * @param options.checkStatus statusをチェックするかどうか（デフォルト: false）
 * @returns 登記取得可能か（所在かつ地番/家屋番号が両方存在し、オプションでstatusがFAILEDでないか）
 */
export const isValidSavedPlotForAcquireBook = (
  plot: SavedMapPlotRequestDetail,
  options?: { checkStatus?: boolean }
): boolean => {
  // エラー行は除外（オプション）
  if (options?.checkStatus && plot.status === "FAILED") {
    return false;
  }

  const realEstateType = plot.realEstateType ?? "土地";
  const hasLocation = Boolean(plot.requestLocation?.trim());
  const hasChibanOrKaoku =
    realEstateType === "土地"
      ? Boolean(plot.requestChiban?.trim())
      : Boolean(plot.requestKaokuNumber?.trim());

  // 登記取得には所在と地番/家屋番号の両方が必須
  return hasLocation && hasChibanOrKaoku;
};
